var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBars = function SvgMenuBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5c0-.415.334-.75.75-.75h12.5c.416 0 .75.335.75.75 0 .416-.334.75-.75.75H3.75A.75.75 0 0 1 3 5m0 5c0-.415.334-.75.75-.75h12.5c.416 0 .75.335.75.75 0 .416-.334.75-.75.75H3.75A.75.75 0 0 1 3 10m14 5c0 .416-.334.75-.75.75H3.75A.75.75 0 0 1 3 15c0-.415.334-.75.75-.75h12.5c.416 0 .75.335.75.75"
  })));
};
export default SvgMenuBars;